/* eslint-disable max-len */
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import InfoIconThick from '../util/icons/components/InfoIconThick';
import './good-beef-section.scss';
import CarbonHoofprintSmallLogo from '../util/logos/CarbonHoofprintSmall';
import MarblingMeaterLogo from '../util/logos/MarblingMeaterLogo';
import ArrowIcon from '../util/icons/components/ArrowIcon';
import GeneticHoofprintLogo from '../util/logos/GeneticHoofprintLogo';

const GoodBeefHomePageSection = () => {
  return (
    <Fragment>
      <div className="good-beef-home-page-section">
        <h1 className="starter">Good Beef</h1>
        <h1 className="punchline">
          is <Link to="/good-beef">
            <span className="final-wrapper">
              good for you<InfoIconThick />
            </span></Link>
        </h1>
        <div className="good-beef-venn">
          <svg
            viewBox="0 0 194 194" >
            <g className="prod-circle">
              <use href="#venn-prod-circle" opacity="0.3" filter="url(#venn-circle-blur)" />
            </g>
            <g className="eat-circle">
              <use href="#venn-eat-circle" opacity="0.3" filter="url(#venn-circle-blur)" />
            </g>
            <g className="env-circle">
              <use href="#venn-env-circle" opacity="0.3" filter="url(#venn-circle-blur)" />
            </g>
            <g clipPath="url(#venn-prod-clip)">
              <g clipPath="url(#venn-eat-clip)">
                <g clipPath="url(#venn-env-clip)" >
                  <use href="#venn-area" fill="#c92f6d" className="tick-shield" />
                  <use className="tick" href="#venn-tick" fill="white" />
                </g>
              </g>
            </g>
          </svg>
          <div className="factor-title environment">
            <Link to="/good-beef/climate-change">
              <div className="factor">
                Carbon Neutral<ArrowIcon className="env-arrow"/>
              </div>
            </Link>
          </div>
          <div className="factor-title eating">
            <Link to="/good-beef/nutritional-value">
              <div className="factor">
                Nutritionally Rich<ArrowIcon className="eat-arrow"/>
              </div>
            </Link>
          </div>
          <div className="factor-title production">
            <Link to="/good-beef/suckler-beef">
              <div className="factor">
                Healthy<ArrowIcon className="prod-arrow" />
              </div>
            </Link>
          </div>
        </div>
      </div>
      <div className="brands">
        <Link to="/good-beef/carbon-negative-beef">
          <div className="carbon-hoofprint-brand brand">
            <CarbonHoofprintSmallLogo />
            <ArrowIcon />
          </div>
        </Link>
        <Link to="/good-beef/marbling">
          <div className="marbling-meater-brand brand">
            <MarblingMeaterLogo />
            <ArrowIcon />
          </div>
        </Link>
        <Link to="/good-beef/genetics">
          <div className="genetic-hoofprint-brand brand">
            <GeneticHoofprintLogo />
            <ArrowIcon />
          </div>
        </Link>
      </div>
    </Fragment>
  );
};

export default GoodBeefHomePageSection;
